"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.createProviderMachine = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _xstate = require("xstate");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _States = require("../../lib/constants/States");
var _utils = require("../../lib/utils");
var _Actions = require("../../lib/constants/Actions");
var _api = require("../../lib/api");
var _gx = require("../../lib/constants/gx");
var _covidVaccineUtils = require("../../lib/covidVaccineUtils");
const actions = {
  setResults: (0, _xstate.assign)({
    provider: (_ctx, ev) => ev.data.providerData.provider,
    locations: (_ctx, ev) => ev.data.providerData.locations,
    insuranceOptions: (_ctx, ev) => ev.data.insuranceOptions,
    gx: (_ctx, ev) => ev.data.gx
  }),
  setEhrPatientDemographics: (0, _xstate.assign)({
    ehrPatientList: (_ctx, ev) => {
      // ev.data.ehrPatientProxyDemographics is only present if show_dropdown and
      // show_related are true

      const mainPatientDemographics = ev.data.ehrPatientDemographics;
      const proxyPatientsDemographics = ev.data.ehrPatientProxyDemographics;
      let patientList = [];
      if (mainPatientDemographics) {
        // Create entry for main patient to be first in list
        patientList.push({
          name: (0, _utils.makeNameString)(mainPatientDemographics.name),
          patient_ids: mainPatientDemographics.patientIds,
          // demographics get populated per use, since the main call
          // returns a full set of demographics, we set there on the main patient
          // since we already have them. The proxy patients' demographics may be
          // incomplete so we need to make a call to fetch those when they are selected
          demographics: mainPatientDemographics
        });
      }
      if (proxyPatientsDemographics && proxyPatientsDemographics.length > 0) {
        patientList = [...patientList, ...proxyPatientsDemographics];
      }
      return patientList;
    }
  }),
  sendParentNext: (0, _xstate.sendParent)(ctx => ({
    type: _Actions.NEXT,
    data: {
      provider: ctx.provider,
      insuranceOptions: ctx.insuranceOptions,
      locations: ctx.locations,
      gx: ctx.gx,
      ehrPatientList: ctx.ehrPatientList,
      selectedPatientIndex: ctx.ehrPatientList && ctx.ehrPatientList.length > 0 ? 0 : null,
      purpose: ctx.purpose
    }
  })),
  /** This is useful for deepLinking since the purpose param does not contain a visit_method
   * Setting it allows the check of certain conditional GX questions
   * (e.g. the telehealth attestation question which can be triggered by a "video" visit_method)
   */
  setApptPurposeVisitMethod: (0, _xstate.assign)({
    purpose: ctx => {
      var _context;
      const visitMethod = (0, _find.default)(_context = ctx.provider.appointment_ehr_purposes).call(_context, _ref => {
        let {
          name,
          patient_relationship
        } = _ref;
        return name === ctx.deepLinkingParams.purpose && patient_relationship === ctx.deepLinkingParams.patientRel;
      })?.ehr_data?.[0]?.visit_method;
      return {
        ...ctx.purpose,
        visit_method: visitMethod ?? null
      };
    }
  }),
  /** Setting the context from which the GX backend will read and respond with relevant GX questons
   * - `current_section: 'conditional'` - a flag that notifies the GX backend we want conditional GX questions (vs non-conditional questions)
   * - `visit_method` - this is passed today as the only condition the GX backend checks on whether to return conditional GX questions (e.g. telehealth attestation feature)
   * NOTE: In the future, we may want to pass in more context (such as patient relationship) which could trigger different conditional GX questions
   */
  setConditionalGxContext: (0, _xstate.assign)({
    gx: ctx => {
      const gxVisitMethod = ctx.purpose?.visit_method ?? null;
      const conditionalGXContext = {
        current_section: _gx.GX_CONTEXT.CURRENT_SECTION.CONDITIONAL,
        visit_method: gxVisitMethod
      };
      const contextualInfo = {
        context: {
          ...ctx.gx.contextualInfo?.context,
          ...conditionalGXContext
        }
      };
      return {
        ...ctx.gx,
        contextualInfo
      };
    }
  }),
  /**
   * apptInfo expects this to be cleared upon apptInfo initialization;
   * apptInfo controls GX context internally because it may also call the GX API for conditional questions
   */
  clearConditionalGxContext: (0, _xstate.assign)({
    gx: ctx => {
      var _context2;
      const {
        context: gxContext
      } = ctx.gx.contextualInfo;
      const filterGxConditionalContextFields = (updatedGxContext, key) => {
        if (!(0, _includes.default)(_gx.GX_CONTEXT_CONDITIONAL_KEYS).call(_gx.GX_CONTEXT_CONDITIONAL_KEYS, key)) {
          return {
            ...updatedGxContext,
            [key]: gxContext[key]
          };
        }
      };
      const filterOutConditionalGxContext = (0, _reduce.default)(_context2 = (0, _keys.default)(gxContext)).call(_context2, filterGxConditionalContextFields, {});
      const contextualInfo = {
        context: filterOutConditionalGxContext
      };
      return {
        ...ctx.gx,
        contextualInfo
      };
    }
  }),
  setConditionalGxQuestions: (0, _xstate.assign)({
    gx: (ctx, ev) => ({
      ...ctx.gx,
      v2Conditionals: ev.data.gx?.v2Conditionals
    })
  }),
  /** set the flag used to check if a call was made to GX API to check for conditional questions using relevant and up to date contextualInfo */
  setConditionalContextualInfoSent: (0, _xstate.assign)({
    gx: ctx => ({
      ...ctx.gx,
      conditionalContextualInfoSent: true
    })
  })
};
const guards = {
  hasNoProviderResults: (_ctx, ev) => {
    const {
      providerData
    } = ev.data;
    return !providerData || !providerData.provider || !providerData.provider.id;
  },
  shouldGetEhrPatientDemographics: ctx => {
    // Check if the app was initialized with ehr data
    const {
      pid,
      pid_type
    } = ctx.ehr ? ctx.ehr : {
      pid: null,
      pid_type: null
    };
    return !!pid && !!pid_type;
  },
  hasDeepLinkedPurposeAndShouldGetEhrPatientDemographics: ctx => {
    const hasDeepLinkedPurpose = !(0, _isEmpty.default)(ctx.deepLinkingParams.purpose);
    // Check if the app was initialized with ehr data
    const {
      pid,
      pid_type
    } = ctx.ehr ? ctx.ehr : {
      pid: null,
      pid_type: null
    };
    return hasDeepLinkedPurpose && !!pid && !!pid_type;
  },
  hasDeepLinkedPurpose: ctx => !(0, _isEmpty.default)(ctx.deepLinkingParams.purpose),
  hasNoConditionalGxQuestions: (ctx, ev) => {
    // gx api call returns 404 if no conditionals are found
    return !ev.data.gx?.v2Conditionals;
  },
  isBookingDisabled: (ctx, ev) => {
    const {
      providerData
    } = ev.data;
    return ctx.dbEnabledProperty && !providerData.provider[ctx.dbEnabledProperty];
  }
};
const services = {
  getData: async ctx => {
    const {
      covidVaccinePatientRegFormConfig,
      patientRegFormConfig,
      customerCode,
      epicOSWConfig,
      gx,
      productName,
      providerId,
      services,
      useProviderInsuranceOnRegForm,
      visibility
    } = ctx;
    const api = new _api.Api(customerCode, productName);
    const [providerData, gxV2] = await _promise.default.all([api.constructProviderObject(services.getProviderById, providerId, epicOSWConfig, visibility), api.getGxStepByProviderId(providerId, gx.contextualInfo)]);
    let gxV1 = null;
    const providerType = providerData?.provider?.provider_type;
    if (providerType) {
      gxV1 = await api.getGxFlowForProviderType(providerType);
    }

    // if we're in the COVID flow and we shouldn't get the insurance plan names
    // for the patient reg form
    let insuranceOptions;
    if ((0, _covidVaccineUtils.isCovidVaccineProvider)(providerData.provider) && !(0, _covidVaccineUtils.shouldLoadXpPlanNames)(covidVaccinePatientRegFormConfig || patientRegFormConfig)) {
      // insurance options empty
      insuranceOptions = [];
    } else if (!useProviderInsuranceOnRegForm) {
      // fetch the insurance plan names for the patient reg form from XP service
      insuranceOptions = await api.getXpPlanNames();
    } else {
      var _context3;
      // get insurance plans from the provider object, sorted
      insuranceOptions = (0, _sort.default)(_context3 = [...(providerData.provider.insurance_accepted || [])]).call(_context3);
    }
    return {
      providerData,
      insuranceOptions,
      gx: {
        v1: gxV1,
        v2: gxV2,
        v2Conditionals: null
      }
    };
  },
  getV2ConditionalsAndGetEhrPatientDemographics: async ctx => {
    const {
      ehr,
      services
    } = ctx;
    const {
      show_dropdown = false,
      show_related = false,
      ...ehrData
    } = ehr;
    const api = new _api.Api(ctx.customerCode);
    const [v2Conditionals, ehrPatientDemographics, ehrPatientProxyDemographics] = await _promise.default.all([api.getGxStepByProviderId(ctx.providerId, ctx.gx.contextualInfo), api.getEhrPatientDemographics(services.getEhrPatientDemographics, ehrData), show_dropdown && show_related ? api.getEhrPatientProxyDemographics(services.getEhrPatientProxyDemographics, ehrData) : null]);
    return {
      gx: {
        ...ctx.gx,
        v2Conditionals
      },
      ehrPatientDemographics,
      ehrPatientProxyDemographics
    };
  },
  getEhrPatientDemographics: async ctx => {
    const {
      ehr,
      services
    } = ctx;
    const {
      show_dropdown = false,
      show_related = false,
      ...ehrData
    } = ehr;
    const api = new _api.Api(ctx.customerCode);
    const [ehrPatientDemographics, ehrPatientProxyDemographics] = await _promise.default.all([api.getEhrPatientDemographics(services.getEhrPatientDemographics, ehrData), show_dropdown && show_related ? api.getEhrPatientProxyDemographics(services.getEhrPatientProxyDemographics, ehrData) : null]);

    // if we fetched the proxy demographics, but not the main patient demographics,
    // we want to pre-fetch the demographics of the first person in the proxy list
    if (ehrPatientProxyDemographics?.length > 0 && !ehrPatientDemographics) {
      const firstProxyDemographics = await api.getEhrPatientDemographics(services.getEhrPatientDemographics, ehrPatientProxyDemographics[0].patient_ids[0]);
      ehrPatientProxyDemographics[0].demographics = firstProxyDemographics;
    }
    return {
      ehrPatientDemographics,
      ehrPatientProxyDemographics
    };
  },
  getV2Conditionals: async ctx => {
    const api = new _api.Api(ctx.customerCode);
    const v2Conditionals = await api.getGxStepByProviderId(ctx.providerId, ctx.gx.contextualInfo);
    return {
      gx: {
        ...ctx.gx,
        v2Conditionals
      }
    };
  }
};

/**
 * @typedef {Object} ProviderMachineProps Properties to build the context on the state machine.
 * @property {number} props.providerId
 * @property {Object} props.epicOSWConfig
 * @property {Object} props.covidVaccinePatientRegFormConfig
 * @property {Object} props.services
 * @property {Object} props.ehr
 * @property {Object} props.ehrPatientList
 * @property {string} props.customerCode
 * @property {Object} props.gx
 */

/**
 * @param {ProviderMachineProps} props
 * @returns {Object} state machine config
 * @note This is exposed for snapshot testing
 */
const machineJSON = _ref2 => {
  let {
    covidVaccinePatientRegFormConfig,
    patientRegFormConfig,
    customerCode,
    dbEnabledProperty,
    deepLinkingParams,
    ehr,
    ehrPatientList,
    epicOSWConfig,
    gx,
    useProviderInsuranceOnRegForm,
    insuranceOptions,
    productName,
    providerId,
    purpose,
    services,
    visibility
  } = _ref2;
  return {
    id: `Machine__${_States.loadingProvider}`,
    initial: _States.pending,
    context: {
      covidVaccinePatientRegFormConfig,
      patientRegFormConfig,
      customerCode,
      dbEnabledProperty,
      deepLinkingParams,
      ehr,
      ehrPatientList,
      epicOSWConfig,
      gx,
      useProviderInsuranceOnRegForm,
      insuranceOptions,
      productName,
      provider: null,
      providerId: providerId,
      purpose,
      services,
      visibility
    },
    states: {
      [_States.idle]: {},
      [_States.success]: {
        entry: 'sendParentNext'
      },
      [_States.noResults]: {},
      [_States.bookingDisabled]: {},
      [_States.pending]: {
        invoke: {
          id: 'getData',
          src: 'getData',
          onDone: [{
            cond: 'hasNoProviderResults',
            target: _States.noResults
          }, {
            cond: 'isBookingDisabled',
            target: _States.bookingDisabled
          }, {
            cond: 'hasDeepLinkedPurposeAndShouldGetEhrPatientDemographics',
            actions: ['setResults',
            // deepLinking does not contain visit_method, thus adding it here so we can later check for certain conditional GX questions (e.g. the telehealth attestation question)
            'setApptPurposeVisitMethod', 'setConditionalGxContext'],
            target: _States.deepLinkedPurposeAndPendingEhrPatientDemographics
          }, {
            cond: 'shouldGetEhrPatientDemographics',
            actions: 'setResults',
            target: _States.pendingEhrPatientDemographics
          }, {
            cond: 'hasDeepLinkedPurpose',
            actions: ['setResults',
            // deepLinking does not contain visit_method, thus adding it here so we can later check for certain conditional GX questions (e.g. the telehealth attestation question)
            'setApptPurposeVisitMethod', 'setConditionalGxContext'],
            target: _States.deepLinkedPurpose
          }, {
            actions: 'setResults',
            target: _States.success
          }],
          onError: _States.noResults
        }
      },
      [_States.deepLinkedPurposeAndPendingEhrPatientDemographics]: {
        exit: ['setConditionalContextualInfoSent', 'clearConditionalGxContext'],
        invoke: {
          id: 'getV2ConditionalsAndGetEhrPatientDemographics',
          src: 'getV2ConditionalsAndGetEhrPatientDemographics',
          onDone: [{
            cond: 'hasNoConditionalGxQuestions',
            actions: 'setEhrPatientDemographics',
            target: _States.success
          }, {
            actions: ['setConditionalGxQuestions', 'setEhrPatientDemographics'],
            target: _States.success
          }],
          onError: _States.success // In the case of an error from fetching ehr data, the user will be brought to blank form with error banner indicating load failure
        }
      },
      [_States.pendingEhrPatientDemographics]: {
        invoke: {
          id: 'getEhrPatientDemographics',
          src: 'getEhrPatientDemographics',
          onDone: {
            actions: 'setEhrPatientDemographics',
            target: _States.success
          },
          onError: _States.success // User will be brought to blank form with error banner indicating load failure
        }
      },
      [_States.deepLinkedPurpose]: {
        exit: ['setConditionalContextualInfoSent', 'clearConditionalGxContext'],
        invoke: {
          id: 'getV2Conditionals',
          src: 'getV2Conditionals',
          onDone: [{
            cond: 'hasNoConditionalGxQuestions',
            target: _States.success
          }, {
            actions: 'setConditionalGxQuestions',
            target: _States.success
          }],
          onError: _States.noResults // during a deepLink, if the conditional GX call fails, we don't want the user to be able to book w/o answering those questions
        }
      }
    }
  };
};
exports.machineJSON = machineJSON;
const createProviderMachine = _ref3 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref3;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createProviderMachine = createProviderMachine;
const makeConfig = () => ({
  services,
  actions,
  guards
});
exports.makeConfig = makeConfig;